// Global (window-level) POS keyboard listeners — the cart shortcuts
// (usePOSKeyboard) and the barcode scanners (BarCodeComponentForRetail /
// BarCodeComponentForNoFocus) — fire regardless of where focus is. They must
// stay INERT while the user is filling in a form presented as an overlay (the
// Add / Edit Customer drawer, and similar Ant Design Drawers / Modals), so that
// "+"/"-" don't change a cart item's quantity and typed characters aren't
// accumulated into a fake scanned barcode that adds a product.
//
// Main-screen POS inputs (product search, quantity, price, customer search) are
// NOT overlays: scanning and the +/- shortcut must keep working there —
// including while a cart item is selected and focus has moved to the quantity
// field (id "sm-amount-input"). Guarding on "any editable field" broke that.
//
// The product search input (id "sm-product-search") is always exempt because a
// few overlays host it (the supermarket product panel drawer, gift card) and
// must keep feeding the scanner.
//
// Returns true only when the keystroke should be ignored by the global handlers.
const isTypingInFormOverlay = (target) => {
  const overlay = target && typeof target.closest === "function" ? target.closest(".ant-drawer, .ant-modal") : null;
  const isProductSearch = target?.id === "sm-product-search";
  const ignore = !!overlay && !isProductSearch;

  return ignore;
};

export default isTypingInFormOverlay;
